import styled, {css} from "styled-components";

const ContainerBox = styled.div`
  margin: 2rem 0;
  padding: 2rem;
  border: ${props => props.theme.lightGrayBorder};
  border-radius: 0.5rem;
  width: 100%;
  .desc {
      font-size: 1.2rem;
  }
  ${props => {
    return (
      props.underlay &&
      css`
        background: ${props => props.theme.lightGray};
      `
    );
  }}
`;

export default ContainerBox;
